module.exports = __webpack_public_path__ + "static/media/wordmark.fcfbf851.svg";